import { csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { css, CSSResult } from 'lit'

export const style: CSSResult = css`
  .spacers {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing08};
  }
  
  .row {
    align-items: center;
    display: flex;
    gap: ${csSpacing.spacing08};
  }
  
  .spacer {
    background: ${csColorText.placeholder};
    height: ${csSpacing.spacing08};
  }
`
